import {type ArticlePromoNewsletterRecord} from '~/_generated/graphql'
import {wysiwygComponentVariants} from '~/cms/components/WYSIWYG/_utils/variants'
import {getBlogNewsletterProps} from '~/cms/helpers/getBlogNewsletterProps'
import {HgArticlePromoNewsletter as HgArticleWYSIWYGPromoNewsletter} from '~/design-system/hg/components'
import {type ArticleWysiwygPromoNewsletterFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGArticlePromoNewsletterProps = ArticleWysiwygPromoNewsletterFragment

export const DatoWYSIWYGNewsletterPromo = (
  props: DatoWYSIWYGArticlePromoNewsletterProps
) => {
  const {promo} = wysiwygComponentVariants()

  return (
    <HgArticleWYSIWYGPromoNewsletter
      {...getBlogNewsletterProps(props as ArticlePromoNewsletterRecord)}
      className={promo()}
    />
  )
}
